import { useEffect, useMemo } from 'react'

import {
  clearExecutionEventMarkers,
  fitMap,
  setExecutionEventMarkers,
  useExecutionEventMarkers as useInitExecutionEventMarkers,
} from '@/map'

export function usePreviewExecutionEventMarkers(
  orderStep: uui.domain.client.rm.ExtendedOrderStep,
  showEventMarkers: boolean,
) {
  // Passing undefined leaves the events empty, so the modal shows only the POD pin.
  const eventMarkers = useInitExecutionEventMarkers(showEventMarkers ? orderStep : undefined)

  const executionEventPositions = useMemo(
    () => eventMarkers.map(marker => marker.latLng),
    [eventMarkers],
  )

  useEffect(() => {
    setExecutionEventMarkers({ visible: true })

    if (executionEventPositions.length > 0) {
      fitMap(executionEventPositions, { minResolution: 3, preventIfVisible: true }, 'clear')
    }
  }, [executionEventPositions])

  // Reset markers on unmount.
  useEffect(() => {
    return () => {
      setExecutionEventMarkers({ visible: false })
      clearExecutionEventMarkers()
    }
  }, [])
}
